import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  key: 1
};
import DefaultStyleMain from './defaultStyleMain.vue';
import Description from './description.vue';
import AllMoviesSeries from './allMoviesSeries.vue';
import AllDirectorsOrActor from './allDirectorsOrActor.vue';
import AllByTopic from './allByTopic.vue';
import ByProperty from './byProperty.vue';
import Minimalism from './minimalism.vue';
import CastOrDirectorDetail from './castOrDirectorDetail.vue';
import CastOrDirectorList from './castOrDirectorList.vue';
import HistoryOrCollection from './historyOrCollection.vue';
import BgTopic from './bgTopic.vue';
import { inject, provide } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'templateGroup',

  setup(__props, {
    expose
  }) {
    const description = reactive({
      visible: false
    });
    const allMovies = reactive({
      visible: false
    });
    const allDirectorOrActor = reactive({
      visible: false
    });
    const allByTopic = reactive({
      visible: false
    });
    const byProperty = reactive({
      visible: false
    });
    const castOrDirectorDetail = reactive({
      visible: false
    });
    const bgTopic = reactive({
      visible: false
    });
    const castOrDirectorList = reactive({
      visible: false
    });
    const historyOrCollection = reactive({
      visible: false
    });
    const datekey = ref(Date.now());
    const currentParams = ref(null);
    provide('currentParams', currentParams);
    const cacheComponentList = ref([]);

    const setCacheCompontentList = (name, params) => {
      currentParams.value = params;
      cacheComponentList.value.push({
        name,
        params
      });
    };

    const onCardClick = item => {
      setDefaultDisplay();
      datekey.value = Date.now();

      if (item.type == 'all') {
        allMovies.visible = true;
        setCacheCompontentList('allMovies', item);
      } else if (item.type == 'by_topic') {
        allByTopic.visible = true;
        setCacheCompontentList('allByTopic', item);
      } else if (item.type == 'topic') {
        bgTopic.visible = true;
        setCacheCompontentList('topic', item);
      } else if (item.type == 'by_property') {
        byProperty.visible = true;
        setCacheCompontentList('byProperty', item);
      } else if (item.type == 'cast') {
        castOrDirectorDetail.visible = true;
        setCacheCompontentList('cast', item);
      } else if (item.type == 'all_actor') {
        allDirectorOrActor.visible = true;
        setCacheCompontentList('all_actor', item);
      } else if (item.type == 'all_director') {
        allDirectorOrActor.visible = true;
        setCacheCompontentList('all_director', item);
      } else if (item.type == 'history_collection') {
        historyOrCollection.visible = true;
        setCacheCompontentList('history_collection', item);
      } else if (item.type == 'castOrDirector_list') {
        castOrDirectorList.visible = true;
        setCacheCompontentList('castOrDirector_list', item);
      } else if (item.type == 'movie' || item.type == 'series' || item.type == 'Program') {
        description.visible = true;
        setCacheCompontentList('description', item);
      }
    };

    const returnBackComponent = () => {
      cacheComponentList.value.length && cacheComponentList.value.pop();

      if (cacheComponentList.value.length) {
        const lastComponentItem = cacheComponentList.value[cacheComponentList.value.length - 1];
        currentParams.value = lastComponentItem.params;
        showComponent(lastComponentItem.name);
      } else {
        toHome();
      }
    };

    const setDefaultDisplay = () => {
      description.visible = false;
      allMovies.visible = false;
      allByTopic.visible = false;
      byProperty.visible = false;
      castOrDirectorDetail.visible = false;
      bgTopic.visible = false;
      castOrDirectorList.visible = false;
      historyOrCollection.visible = false;
      allDirectorOrActor.visible = false;
    };

    const toHome = () => {
      cacheComponentList.value = [];
      setDefaultDisplay();
    };

    const showComponent = name => {
      setDefaultDisplay();
      datekey.value = Date.now();

      switch (name) {
        case 'description':
          description.visible = true;
          break;

        case 'allMovies':
          allMovies.visible = true;
          break;

        case 'allByTopic':
          allByTopic.visible = true;
          break;

        case 'topic':
          bgTopic.visible = true;
          break;

        case 'byProperty':
          byProperty.visible = true;
          break;

        case 'cast':
          castOrDirectorDetail.visible = true;
          break;

        case 'all_actor':
          allDirectorOrActor.visible = true;
          break;

        case 'all_director':
          allDirectorOrActor.visible = true;
          break;

        case 'castOrDirector_list':
          castOrDirectorList.visible = true;
          break;

        case 'history_collection':
          historyOrCollection.visible = true;

        default:
          break;
      } // console.log('cacheComponentList', cacheComponentList);

    };

    expose({
      cacheComponentList,
      returnBackComponent,
      onCardClick,
      toHome
    });
    const currentUiStyleOptions = inject('currentUiStyleOptions');
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_unref(currentUiStyleOptions).styleName == 'default' || _unref(currentUiStyleOptions).styleName == 'arabic' ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives(_createElementVNode("div", null, [_createVNode(DefaultStyleMain, {
        onOnCardClick: onCardClick
      })], 512), [[_vShow, !description.visible && !allMovies.visible && !allByTopic.visible && !byProperty.visible && !castOrDirectorDetail.visible && !bgTopic.visible && !castOrDirectorList.visible && !historyOrCollection.visible && !allDirectorOrActor.visible]])])) : _createCommentVNode("", true), _unref(currentUiStyleOptions).styleName == 'style1' || _unref(currentUiStyleOptions).styleName == 'style2' ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_withDirectives(_createElementVNode("div", null, [_createVNode(Minimalism, {
        onOnCardClick: onCardClick
      })], 512), [[_vShow, !description.visible && !allMovies.visible && !allByTopic.visible && !byProperty.visible && !castOrDirectorDetail.visible && !bgTopic.visible && !castOrDirectorList.visible && !historyOrCollection.visible && !allDirectorOrActor.visible]])])) : _createCommentVNode("", true), description.visible ? (_openBlock(), _createBlock(Description, {
        key: datekey.value,
        onOnCardClick: onCardClick
      })) : _createCommentVNode("", true), allMovies.visible ? (_openBlock(), _createBlock(AllMoviesSeries, {
        key: datekey.value,
        onOnCardClick: onCardClick
      })) : _createCommentVNode("", true), allDirectorOrActor.visible ? (_openBlock(), _createBlock(AllDirectorsOrActor, {
        key: datekey.value,
        onOnCardClick: onCardClick
      })) : _createCommentVNode("", true), allByTopic.visible ? (_openBlock(), _createBlock(AllByTopic, {
        key: datekey.value,
        onOnCardClick: onCardClick
      })) : _createCommentVNode("", true), byProperty.visible ? (_openBlock(), _createBlock(ByProperty, {
        key: datekey.value,
        onOnCardClick: onCardClick
      })) : _createCommentVNode("", true), castOrDirectorDetail.visible ? (_openBlock(), _createBlock(CastOrDirectorDetail, {
        key: datekey.value,
        onOnCardClick: onCardClick
      })) : _createCommentVNode("", true), bgTopic.visible ? (_openBlock(), _createBlock(BgTopic, {
        key: datekey.value,
        onOnCardClick: onCardClick
      })) : _createCommentVNode("", true), castOrDirectorList.visible ? (_openBlock(), _createBlock(CastOrDirectorList, {
        key: datekey.value,
        onOnCardClick: onCardClick
      })) : _createCommentVNode("", true), historyOrCollection.visible ? (_openBlock(), _createBlock(HistoryOrCollection, {
        key: datekey.value,
        onOnCardClick: onCardClick
      })) : _createCommentVNode("", true)], 64);
    };
  }

});